// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import { QueryPagination } from '../../commons/interfaces';
import {
  getAllKnowledgeBasesService,
  getKnowledgeBaseByIdService,
  createKnowledgeBaseService,
  updateKnowledgeBaseService,
  deleteKnowledgeBaseService,
  restoreKnowledgeBaseService,
  getFormToDropdownService,
} from '../../services/knowledgeBases.service';
import {
  setKnowledgeBasesListRedux,
  storeKnowledgeBaseRedux,
  setKnowledgeBasesFormDropdownRedux,
} from './knowledgeBasesSlice';

export const getAllKnowledgeBases =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await getAllKnowledgeBasesService(query);

      if (response?.ok) {
        dispatch(setKnowledgeBasesListRedux(response));
      }

      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getDataFormDropDownStore = () => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await getFormToDropdownService();
    if (response?.ok && response?.data) {
      dispatch(setKnowledgeBasesFormDropdownRedux(response.data));
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const getKnowledgeBaseById = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await getKnowledgeBaseByIdService(id);

    if (response?.ok) {
      dispatch(storeKnowledgeBaseRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const createKnowledgeBase =
  (data: any, setPercentageUpload?: any) => async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await createKnowledgeBaseService(data, setPercentageUpload);

      if (response?.ok) {
        // Aquí podrías despachar al estado la lista actualizada si fuera necesario.
      }

      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const updateKnowledgeBase =
  (id: string, data: any, setPercentageUpload?: any) => async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await updateKnowledgeBaseService(id, data, undefined, setPercentageUpload);

      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const deleteKnowledgeBase =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await deleteKnowledgeBaseService(id, query);

      if (response?.ok) {
        dispatch(setKnowledgeBasesListRedux(response));
      }

      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const restoreKnowledgeBase =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await restoreKnowledgeBaseService(id, query);

      if (response?.ok) {
        dispatch(setKnowledgeBasesListRedux(response));
      }

      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };
